import * as React from 'react';
import Modal from 'antd/lib/modal';
import Button from 'antd/lib/button';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { UserData, StylesProps } from 'src/Library/Types';
import withStyles from 'react-jss';
import { acceptPrivacyAgreement } from 'src/api/account';
import { message } from 'antd';
import { setPrivacyAgreement } from 'src/actions/loadInitialData';
const sheildCheck = require('src/assets/images/shieldCheck.svg');

const styles = {
  modalClass: {
    '& .ant-modal-body': {
      padding: '24px 16px 12px 16px',
      borderRadius: 5,
    },
    display: 'flex',
    flexDirection: 'column',
  },
  icon: {
    height: 54,
  },
  flexRow: {
    display: 'flex',
    justifyContent: 'space-around',
  },
  greeting: {
    color: '#262626',
    fontFamily: 'Open Sans',
    fontSize: 16,
    fontWeight: 'bold',
    letterSpacing: 0,
  },
  message: {
    textAlign: 'center',
    color: '#262626',
    fontSize: 12,
    fontWeight: 550,
    letterSpacing: 0,
    lineHeight: '18px',
    fontFamily: 'Open Sans',
  },
};

interface IProps extends StylesProps<typeof styles>{
  userData: UserData;
  setPrivacyAgreement: () => void;
}

const PrivacyPolicy = (props: IProps) => {
  const { userData, classes, setPrivacyAgreement } = props;
  const { privacy_policy_accepted } = userData;

  const [creating, setCreating] = React.useState<boolean>(false);

  const renderIcon = () => {
    return (
      <div className={classes.flexRow}>
        <img className={classes.icon} src={sheildCheck} />
      </div>
    );
  };

  const renderGreetings = () => {
    return (
      <div
        className={classes.flexRow}
        style={{
          marginTop: 8,
        }}
      >
        <h3 className={classes.greeting}>Hello There!</h3>
      </div>
    );
  };

  const renderMessage = () => {
    return (
      <div className={classes.flexRow}>
        <p className={classes.message}>
          Shipsy has updated it's
          <a rel="noreferrer" target="_blank" href="https://shipsy.in/privacy-policy/">
            {' Privacy Policy'}
          </a>
          . Please read the document, as it states about your legal rights & data privacy.
        </p>
      </div>
    );
  };

  const renderContinueMessage = () => {
    return (
      <div
        className={classes.flexRow}
        style={{
          marginTop: 2,
        }}
      >
        <p className={classes.message}>By continuing, you agree to these updates.</p>
      </div>
    );
  };

  const acceptAgreement = async () => {
    setCreating(true);
    const response = await acceptPrivacyAgreement();
    if (response.isSuccess) {
      message.success('Thank You');
      setPrivacyAgreement();
    } else {
      message.error(response.errorMessage);
    }
    setCreating(false);
  };

  const renderButton = () => {
    return (
      <div
        className={classes.flexRow}
        style={{
          marginTop: 2,
        }}
      >
        <Button
          loading={creating}
          type="primary"
          onClick={acceptAgreement}
        >
          I Agree
        </Button>
      </div>
    );
  };

  return (
    <Modal
      className={classes.modalClass}
      width={386}
      visible={!privacy_policy_accepted}
      closable={false}
      footer={null}
    >
      {renderIcon()}
      {renderGreetings()}
      {renderMessage()}
      {renderContinueMessage()}
      {renderButton()}
    </Modal>
  );
};

const mapStateToProps = ({ masterData }) => {
  const { userData } = masterData;
  return {
    userData,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({
    setPrivacyAgreement,
  }, dispatch);
};

const PrivacyPolicyStyled = withStyles(styles)(PrivacyPolicy);
export default connect(mapStateToProps, mapDispatchToProps)(PrivacyPolicyStyled);
